<div class="sh-facet">
    <div *ngIf="showLabel" class="sh-facet__label sh-facet-placeholder-background sh-facet-placeholder-title"></div>
    <ul class="sh-facet__values sh-form-check-list">
        <li *ngFor="let _ of [].constructor(4); let i = index;" class="sh-form-check sh-facet__values__value sh-form-check-list__item">
            <div
                class="sh-form-check sh-form-check-list__item__check sh-facet-placeholder-background sh-facet-placeholder-value"
                [style]="'animation-delay: '+ i/8 + 's;'"
            ></div>
        </li>
    </ul>
</div>
